import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-plus",
  "use": "icon-plus-usage",
  "viewBox": "0 0 9 9",
  "content": "<symbol fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 9 9\" id=\"icon-plus\"><path d=\"M4.383.952v3.6h-3.6V5.4h3.6V9h.848V5.4h3.6v-.848h-3.6v-3.6h-.848Z\" fill=\"currentColor\" /><path d=\"M4.383.952v3.6h-3.6V5.4h3.6V9h.848V5.4h3.6v-.848h-3.6v-3.6h-.848Z\" fill=\"currentColor\" fill-opacity=\".2\" /><path d=\"M4.383.952v3.6h-3.6V5.4h3.6V9h.848V5.4h3.6v-.848h-3.6v-3.6h-.848Z\" fill=\"currentColor\" fill-opacity=\".2\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol